
const Watermark = () => {
  return <div className="app-watermark" />;
};

export default Watermark;
